<template>
  <BasePage title='Settings'>

    <Loader v-if="loading"/>
    <section v-else class="columns">
      <div class="column is-10-tablet is-offset-1-tablet is-8-desktop is-offset-2-desktop is-6-fullhd is-offset-3-fullhd">
        <h2 class="title is-2 pt-0 mt-0">Settings</h2>
        <section class="d-flex">

          <div>
            <figure class="image is-96x96">
              <img :src="avatarURL"/>
            </figure>
            <figcaption class="text-center">
              change at <a href="http://en.gravatar.com/support/activating-your-account/">gravatar</a>
            </figcaption>
          </div>

          <section class="ml-5 grow-1">

        <SettingsProfileField
          :title="'display name'"
          :value="name"
          :placeholder="'Jane Doe'"
          :save="saveName"/>

            <label class="fs-6">email address</label>
            <h3 class="title is-4 mb-1">{{ email }}</h3>
          </section>
        </section>

        <label class="fs-6">classforward birthday</label>
        <h3 class="title is-4 mb-1">{{ bday | formatTextDate }}</h3>

        <SettingsProfileField
          :title="'content area'"
          :value="contentArea"
          :placeholder="'Mathematics'"
          :save="saveContentArea"
          class="mt-3"/>

        <SettingsProfileField
          :title="'position'"
          :value="position"
          :placeholder="'Teacher'"
          :save="savePosition"
          class="mt-3"/>

        <SettingsProfileField
          :title="'school'"
          :value="school"
          :placeholder="'Anytown High'"
          :save="saveSchool"
          class="mt-3"/>

        <SettingsProfileField
          :title="'grade'"
          :value="grade"
          :placeholder="'8'"
          :save="saveGrade"
          class="mt-3"/>

        <section v-if="!isPro">
          <label class="fs-6">license</label>
          <h3 class="title is-4 mb-1 d-flex align-items-center">
            <div class="activated-circle"></div>
            Activated<span v-if="expiresOn">&nbspthrough {{ expiresOn | formatTextDate }}</span></h3>
        </section>

        <h2 class="title is-3 mb-2 mt-4">Login</h2>

        <router-link v-if="hasUsablePassword" to="/change-password">Change password</router-link>
        <router-link v-else to="/set-password">Set password</router-link>

        <h2 class="title is-3 mb-2 mt-4">Social Login</h2>

        <SocialConnect :accounts="socialAccounts"/>

        <h2 class="title is-3 mb-2 mt-4">Email Notifications</h2>
        <EmailSettingField
          :description="'Send me an email when videos are shared with me:'"
          :value="emailEnabled"
          :save="setEmailNotifications"/>

      </div>
    </section>
  </BasePage>
</template>

<script>
import {
  updateUser,
  fetchUser,
  fetchSocialAccountConnections,
  generalErrorHandler,
} from '../actionTypes'

import { formatTextDate } from '../filters.js'

import Loader from './Loader'
import BasePage from './BasePage.vue'
import SettingsProfileField from './SettingsProfileField'
import EmailSettingField from './EmailSettingField'
import store from '../store'

import SocialConnect from './SocialConnect'

export default {
  name: 'Settings',
  components: {
    BasePage,
    SettingsProfileField,
    EmailSettingField,
    Loader,
    SocialConnect,
  },
  data () {
    return {
      loading: true,
    }
  },
  filters: {
    formatTextDate,
  },
  async mounted () {
    try {
      await Promise.all([
        store.dispatch(fetchUser),
        store.dispatch(fetchSocialAccountConnections),
      ])
    } catch (error) {
      store.dispatch(generalErrorHandler, { error })
    }
    this.loading = false
  },
  computed: {
    avatarURL () {
      return store.state.user.avatar_url
    },
    name () {
      return store.state.user.name
    },
    email () {
      return store.state.user.email
    },
    emailEnabled () {
      return store.state.user.email_notifications_enabled
    },
    contentArea () {
      return store.state.user.content_area
    },
    position () {
      return store.state.user.position
    },
    school () {
      return store.state.user.school
    },
    grade () {
      return store.state.user.grade
    },
    bday () {
      return store.state.user.date_joined
    },
    isPro () {
      return store.state.user.is_pro
    },
    expiresOn () {
      return store.state.user.expires_on
    },
    hasUsablePassword () {
      return store.state.user.has_usable_password
    },
    socialAccounts () {
      return store.state.socialAccountConnections
    },
  },
  methods: {
    setEmailNotifications (value) {
      return store.dispatch(updateUser, { email_notifications_enabled: value })
    },
    saveName (value) {
      return store.dispatch(updateUser, { name: value })
    },
    saveContentArea (value) {
      return store.dispatch(updateUser, { content_area: value })
    },
    savePosition (value) {
      return store.dispatch(updateUser, { position: value })
    },
    saveGrade (value) {
      return store.dispatch(updateUser, { grade: value })
    },
    saveSchool (value) {
      return store.dispatch(updateUser, { school: value })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../_variables.scss';

.activated-circle {
  width: .75rem;
  height: .75rem;;
  background: $SUCCESS;
  border-radius: 100%;
  margin-right: 0.5rem;
  box-shadow: 0px 0px 3px 0px transparentize($SUCCESS, 0.2);
}

img {
  border-radius: 5px;
}

figcaption {
  margin-top: .25rem;
  line-height: 1.1;
  max-width: 96px;
}

.min-height-3 {
  min-height: 3rem;
}

.italics {
  font-style: italic;
}

.mt-0 {
  margin-top: 0;
}
</style>



// WEBPACK FOOTER //
// Settings.vue?e9d395b6